/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { contentText, titleText } from "@monsma/App/WidgetExtensions/OrderDetails/OrderDateExtension";
import { orderInformationStyles } from "@monsma/Overrides/Widgets/OrderApprovalDetails/OrderApprovalDetailsOrderInformation";
import { css } from "styled-components";

orderInformationStyles.orderInformationGridContainer = {
    gap: 30,
};

orderInformationStyles.mainInformationGridItem = {
    width: 12,
};

orderInformationStyles.shippingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
};

orderInformationStyles.billingInformationGridItem = {
    width: [12, 6, 6, 6, 6],
};

orderInformationStyles.notesGridItem = {
    width: 12,
};

orderInformationStyles.mainInformationGridContainer = {
    gap: 15,
};

orderInformationStyles.orderNumberGridItem = {
    width: [12, 6, 4, 4, 4],
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

orderInformationStyles.orderDateGridItem = orderInformationStyles.orderNumberGridItem;

orderInformationStyles.poNumberGridItem = orderInformationStyles.orderNumberGridItem;

orderInformationStyles.statusGridItem = orderInformationStyles.orderNumberGridItem;

orderInformationStyles.orderNumberTitle = titleText;
orderInformationStyles.orderNumberText = contentText;

orderInformationStyles.orderDateTitle = titleText;
orderInformationStyles.orderDateText = contentText;

orderInformationStyles.poNumberTitle = titleText;
orderInformationStyles.poNumberText = contentText;

orderInformationStyles.statusTitle = titleText;
orderInformationStyles.statusText = contentText;

orderInformationStyles.notesTitle = titleText;
orderInformationStyles.notesDescription = contentText;

orderInformationStyles!.xOrderInfo = {
    addressesGridItem: {
        width: 12,
    },
    addressesContainer: {
        gap: 30,
    },
    shippingInformationCarrierGridItem: orderInformationStyles.orderNumberGridItem,
    shippingInformationDateRequestedGridItem: orderInformationStyles.orderNumberGridItem,
    shippingInformationServiceGridItem: orderInformationStyles.orderNumberGridItem,
    shippingCarrierTitle: titleText,
    shippingCarrierText: contentText,
    shippingDateRequestedTitle: titleText,
    shippingDateRequestedText: contentText,
    shippingServiceTitle: titleText,
    shippingServiceText: contentText,
};
